/**
 * Free-text memo helpers shared by sub-step memo, approval memo, cancellation
 * memo, and completion memo. Approval / cancellation / completion memo stay
 * limited to 100 characters to match protovalidate `string.max_len` and the
 * Go `len([]rune(...))` check (spec §決定の経緯「サブステップメモの入力
 * ルール」: 承認メモ / 完了メモは 100 文字据え置き).
 */
export const MEMO_MAX_LENGTH = 100

/**
 * Sub-step memo (SubStepMemoDialog) upper bound: 500 characters (spec
 * AC-WFW-005b「最大 500 文字」, slice #7328 / #7054). Deliberately a separate
 * constant from MEMO_MAX_LENGTH so approval / cancellation memo do not widen
 * along with it.
 */
export const SUB_STEP_MEMO_MAX_LENGTH = 500

/** Counts code points (not UTF-16 code units) so the limit aligns with backend. */
export const memoLength = (value: string): number => Array.from(value).length

/** Truncates a memo to the given maximum code-point length. */
export const truncateMemo = (value: string, maxLength: number): string =>
  memoLength(value) <= maxLength
    ? value
    : Array.from(value).slice(0, maxLength).join('')

/** Returns a trimmed memo, or `undefined` when the value is empty/whitespace. */
export const normalizeMemo = (value: string): string | undefined => {
  const trimmed = value.trim()
  return trimmed === '' ? undefined : trimmed
}
